// Edit partner details here.
// - Leave `image` empty to show the branded initials placeholder.
// - Leave `linkedinUrl` or `bio` empty to hide them.
// - `imagePosition` sets the photo's focal point; `imageZoom` crops in tighter (1 = no zoom).
export const partners = [
  {
    name: 'Peter I.',
    firstName: 'Peter',
    initials: 'PI',
    title: 'Search Executive Partner',
    email: 'Peter@risingtalentpartners.com',
    image: 'https://cdn.magicpatterns.com/uploads/nDpSB5ysD2Q1FPstwTnKCh/IMG_2554.jpg',
    imageAlt: 'Portrait of Peter I.',
    imagePosition: '50% 30%',
    imageZoom: 1,
    bio: '',
    linkedinUrl: 'https://www.linkedin.com/in/peter-i-08799b257',
  },
  {
    name: 'Samuel Blessing',
    firstName: 'Samuel',
    initials: 'SB',
    title: 'Search Executive Partner',
    email: 'Samuel@risingtalentpartners.com',
    image:
      'https://cdn.magicpatterns.com/uploads/6xh5ZBfkDWt4CWyEBoS762/47f00609-8a9f-4d9e-b554-724228282264.jpg',
    imageAlt: 'Portrait of Samuel Blessing',
    imagePosition: '52% 42%',
    imageZoom: 1.45,
    bio: '',
    linkedinUrl: '', // Add Samuel's LinkedIn profile URL here to show the button.
  },
];

// Wider executive search team. Add `image` or `linkedinUrl` fields later if they become available.
export const teamMembers = [
  {
    name: 'Deborah A.',
    firstName: 'Deborah',
    initials: 'DA',
    title: 'Executive Search Team',
    email: 'deborah.risingtalentpartner@gmail.com',
  },
  {
    name: 'Blessing S.',
    firstName: 'Blessing',
    initials: 'BS',
    title: 'Executive Search Team',
    email: 'blessing.risingtalentpartner@gmail.com',
  },
  {
    name: 'Isaiah A.',
    firstName: 'Isaiah',
    initials: 'IA',
    title: 'Executive Search Team',
    email: 'Isaiah.risingtalentpartner@gmail.com',
  },
];
